import { signedFetch } from './client';

export async function listSchemas(storeName: string) {
  return signedFetch('GET', `/stores/${storeName}/schemas`);
}

export async function registerSchema(storeName: string, eventType: string, version: number, schema: object) {
  return signedFetch('POST', `/stores/${storeName}/schemas`, { eventType, version, schema });
}
